<template>
    <div class="home">
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.home {
    background: url(./images/bg.png) no-repeat center center;
    height: 100%;
    width: 100%;
    background-size: cover;
}
</style>